<template>
	<!--环境-->
		<div class="huanjingright" v-loading="loading">
			<div style="display: flex;flex-wrap: wrap;">
				<div  @click="tiaozhuans(item.url)" class="huanjingrights" @mouseenter="mouseenter($event,i)" @mouseleave="mouseleave($event,i)" v-for="(item,i) in list" :key="i">
					<img src="../../assets/zanwu.png" v-if="!item.icon" class="zhubeijing" alt="">
					<img :src="item.icon" v-if="item.icon" class="zhubeijing" alt="">
					
					<div style="width: 100%;height: 60px;position: absolute;bottom: 0px;z-index: 2;">
						<div style="width: 100%;height: 100%;background: #037db3;opacity: 0.5;"></div>
						<div class="tiaozhuan" style="cursor: pointer;">
							<div style="width: 80%;position: relative;display: flex;align-items: center;">
								<div class="jhsas" style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
									{{item.title}}
								</div>
								<img src="../../assets/xanyou.png" style="width: 30px;" alt="">
							</div>
							<img :src="item.slogo" alt="" v-if="item.slogo" class="slogis">
			<!-- 				<div class="imagss" v-if="!item.slogo">暂无</div> -->
						</div>
					</div>
					
					<!--申请运行资源 申请上线运行-->
					<div class="shenqing" v-if="(item.type==3 || item.type==4) && item.select==true">
						<div class="shenqings" @click.stop="user_is_huanjing(item,1)">申请运行资源</div>
						<div class="shenqings" @click.stop="user_is_huanjing(item,2)">申请上线运行</div>
						<div class="shenqings" v-if="item.type==3" @click.stop="shenqingjiaru(item.id,item.title)">申请加入</div>
						<div class="shenqings" v-if="item.type==3" style="margin-top: 10px;" @click.stop="xufeidata(item.id)">用户续费</div>
					</div>
					
				</div>
				
				<!--申请运行资源-->
				<yunxing ref="yunxingdata" @yunxingsucc="yunxingsucc"></yunxing>
				<!--申请运行资源-->
				<!--申请上线运行-->
				<shangxian ref="shangxiandata" @shangxiansucc="shangxiansucc"></shangxian>
				<!--申请上线运行-->
			</div>
			
			<!-- 分页 -->
			<div class="pagination-container" style="margin-top: 40px;margin-left: 20px;">
			  <el-pagination
			    :current-page="query.page"
			    :page-sizes="[8,20,30, 40]"
			    :page-size="query.limit"
			    :total="total"
			    background layout="total, sizes, prev, pager, next, jumper"
			    @size-change="handleSizeChange"
			    @current-change="handleCurrentChange"
			  />
			</div>
			<!--用户续费-->
			<userxufei ref="xufeidata" @succ="xufeichenggong"></userxufei>
			<!--用户续费-->
		</div>
	<!--环境-->
</template>

<script>
	import { huanjing_look } from "@/api/huanjing"
	import { getToken } from '@/utils/auth'
	import Cookies from 'js-cookie'
	import yunxing from "@/views/yunxing/index"
	import shangxian from "@/views/yunxing/shangxian"
	import userxufei from "@/views/erqi/userxufei"
	export default {
		components:{
			yunxing,shangxian,userxufei
		},
		data(){
			return{
				query:{
					page:1,
					limit:8,
					type:1,
					status:2
				},
				total:0,
				list:[],
				loading:false,
				
			}
		},
		mounted() {
			this.query.type = this.$route.query.type?this.$route.query.type:1;
			this.huanjing_look();
		},
		methods: {
			tiaozhuans(url){
				window.open(url, '_blank');
			},
			//用户续费
			xufeidata(huanjingid){
				if(getToken()){
					this.$refs.xufeidata.show(huanjingid)
				}else{
					loginEvent.$emit('loginDialogEvent')
				}
				
			},
			xufeichenggong(orderid){
				this.$router.push({
					path:"/neirong",
					query:{
						orderid:orderid,
						neirongtype:5
					}
				})
			},
		  huanjing_look(){
			  this.loading = true
			  huanjing_look(this.query).then(res=>{
				  this.loading = false
				  console.log("环境列表",res.data);
				  res.data.list.forEach(r=>{
					  r.select = false
				  })
				  this.total = res.data.total
				  this.list = res.data.list
				  
			  }).catch(()=>{
				  this.loading = false
			  })
		  },
		  //下一页上一页操作
		  handleSizeChange(val) {//条数
		    this.query.limit = val
			this.huanjing_look();
		  },
		  handleCurrentChange(val) {//列数
		    this.query.page = val
			this.huanjing_look();
		  },
		  //共享环境申请加入
		  shenqingjiaru(id,title){
		  	//需要先判断是否登录
		  	if(getToken()){
		  		//如果是共享环境开发
		  		if(this.query.type==3){
		  			this.$router.push({
		  				path:"/gongxiangsave",
		  				query:{
		  					huanjingid:id,
		  					title:title
		  				}
		  			})
		  		}
		  	}else{
		  		loginEvent.$emit('loginDialogEvent')
		  	}
		  },
		  //申请运行资源成功以后进行跳转订单
		  yunxingsucc(orderid){
		  	this.$router.push({
		  		path:"/neirong",
		  		query:{
		  			orderid:orderid,
		  			neirongtype:2
		  		}
		  	})
		  },
		  shangxiansucc(orderid){
		  	this.$router.push({
		  		path:"/neirong",
		  		query:{
		  			orderid:orderid,
		  			neirongtype:3
		  		}
		  	})
		  },
		  user_is_huanjing(item,st){
		  	//申请运行资源
		  	if(st==1){
		  		this.$refs.yunxingdata.show(item);
		  	}
		  	//申请上线运行
		  	if(st==2){
		  		this.$refs.shangxiandata.show(item)
		  	}
		  },
		  mouseenter($event,i){
		  	this.list.forEach((r,j)=>{
		  		if(i==j){
		  			r.select = true
		  		}else{
		  			r.select = false
		  		}
		  	})
		  },
		  mouseleave($event,i){
		  	this.list.forEach((r,j)=>{
		  		if(i==j){
		  			r.select = false
		  		}
		  	})
		  },
		},	
	}
</script>

<style lang="scss" scoped>
	.huanjingleft03s{
		width: 162px;
		// height: 93%;
		margin-left: auto;
		// border-bottom: 2px solid #00b0f0;
		.huanjingleft03ss{
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
		}
	}
	.jiaru{
		width: 80px;
		position: absolute;
		right: 20px;
		bottom: 62px;
		z-index: 2;
		display: flex;
		.jiarus{
			width: 100%;
			height: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			color: #fff;
			font-size: 16px;
			cursor: pointer;
		}
	}
	.shenqing{
		width: 100%;
		height: 78%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		position: absolute;
		left: 0px;
		top: 0px;
		z-index: 2;
		.shenqings{
			width: 40%;
			height: 30px;
			border: 2px solid #fff;
			border-radius: 10px;
			display: flex;
			align-items: center;
			justify-content: center;
			color: #fff;
			font-size: 16px;
			cursor: pointer;
			transition: all 1s;
		}
		.shenqings:nth-child(2){
			margin-top: 10px;
			margin-bottom: 10px;
		}
		
	}
	.tiaozhuan:hover{
		color: #00b0f0;
	}
	.tiaozhuan{
		width: 245px;
		position: absolute;
		left: 16px;
		height: 20px;
		bottom: 19px;
		display: flex;
		align-items: center;
		color: #fff;
		font-size: 16px;
		z-index: 2;
		.slogis{
			width: 40px;
			height: 20px;
			margin-left: auto;
			cursor: pointer;
		}
		.imagss{
			width: 40px;
			height: 25px;
			background: #fff;
			opacity: 0.5;
			display: flex;
			align-items: center;
			justify-content: center;
			color: #333;
			font-size: 12px;
			margin-left: auto;
		}
	}
	.ssinput{
		background: none;
		border: none;
		width: 70%;
		height: 100%;
		outline: none;
	}
	.el-icon-searchsss{
		margin-left: auto;
		cursor: pointer;
	}
	.huanjingleft{
		width: 252px;
		height: 280px;
		position: relative;
		.huanjingleft01{
			color: #333;
			font-size: 32px;
		}
		.huanjingleft02{
			color: #999999;
			font-size: 14px;
			margin-top: 10px;
		}
		.huanjingleft03{
			width: 100%;
			height: 80px;
			position: absolute;
			left: 0px;
			bottom: 0px;
	
		}
	}
	.huanjingright{
		width: 1200px;
		margin: 0 auto;
		// height: 280px;
		
		// align-items: center;
		// margin-left: auto;
		.huanjingrights{
			width: 280px;
			height: 280px;
			background: #767676;
			position: relative;
			cursor: pointer;
			transition: all 1s;
			margin-left:20px;
			.zhubeijing{
				width: 100%;
				height: 100%;
				position: absolute;
				z-index: 1;
			}
		}
		.huanjingrights:hover{
				transform: scale(1.05);
		}
		.huanjingrights:hover .jhsas{
			color: #00b0f0;
		}
	}
	.list05{
		width: 48%;
		.list05s:hover{
			color: #00b0f0;
		}
		.list05s{
			width: 100%;
			display: flex;
			align-items: center;
			padding-top: 5px;
			padding-bottom: 5px;
			cursor: pointer;
			color: #747474;
			font-size: 14px;
			.list05title{
				width: 70%;
				
				text-overflow: ellipsis;
				overflow: hidden;
				white-space: nowrap;
			}
			.list05time{
				margin-left: auto;
			}
			img{
				width: 20px;
				margin-left: -10px;
			}
		}
	}
	.nav{
		display: flex;
		align-items: center;
		cursor: pointer;
		.navss{
			position: relative;
			color: #00b0f0!important;
		}
		.navss:after{
			content: '';
			display: block;
			width: 83%;
			height: 3px;
			background-color: #00b0f0;
			position: absolute;
			left: 50%;
			margin-left: -41.5%;
			bottom: -12px;
		}
		.navs{
		
			text-align: center;
			color: #404040;
			font-size: 26px;
			padding-left:20px;
			padding-right: 20px;
			cursor: pointer;
			position: relative;
			display: flex;
			align-items: center;
			// letter-spacing: 0.1em;
			img{
				width: 30px;
				height: 30px;
				margin-right: 15px;
			}
		}
		.navssss:before{
			content: '';
			display: block;
			width: 1px;
			height: 26px;
			background-color: #d5d5d5;
			position: absolute;
			top: 8px;
			right: 0;
		}
	}
	.huati001:hover{
		color: #00b0f0;
	}
	.huati003:hover{
		color: #00b0f0;
	}
	.h01:hover{
		color: #00b0f0;
	}
	.h02:hover{
		color: #00b0f0;
	}
	.huati{
		width: 100%;
		height: 100%;
		margin-top: 20px;
		.clears{
			width: 1px;
			height: 50px;
			background: #ececec;
			margin-left: 5px;
			
		}
		.huatis{
			width: 100%;
			height: 72px;
			display: flex;
			align-items: center;
			margin-left: 15px;
			cursor: pointer;
			.huati02{
				width: 270px;
				height: 100%;
				display: flex;
				justify-content: center;
				flex-direction: column;
				margin-left: auto;
				.h01{
					    text-overflow: ellipsis;
					    overflow: hidden;
					    white-space: nowrap;
					    font-size: 16px;
					    color: #747474;
				}
			    .h02{
					margin-top: 8px;
					    font-size: 14px;
					    color: #747474;
				}
			}
			.huati01{
				width: 45px;
				height: 100%;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				.huati001{
					font-size: 16px;
					color: #747474;
				}
				.huati002{
					    width: 5px;
					    height: 5px;
					    background-color: #747474;
					    border-radius: 10px;
						margint-top:5px;
						margin-bottom: 5px;
				}
				.huati003{
					line-height: 17px;
					    font-size: 12px;
					    color: #747474;
				}
			}
		}
	}
	.wrappers02{
		width: 345px;
		margin-right: 5px;
		height: 100%;
		.flexgb{
			width: 100%;
			height: 57px;
			border-bottom: 1px solid #bbcae6;
			display: flex;
			align-items: center;
			.flexAc{
				color: #00b0f0;
				font-size: 14px;
				margin-left: auto;
				height:100%;
				display: flex;
				align-items: center;
				justify-content: center;
				cursor: pointer;
			}
		}
	}
	.transition{
		width: 95%;
		margin: 0 auto;
		.list{
			width: 100%;
			height: 390px;
			padding-top: 38px;
			display: flex;
			.lists{
				width: 48%;
				height: 100%;
				cursor: pointer;
				.list04:hover{
					color: #00b0f0;
				}
				.list04{
					margin: 20px 0 0;
					padding-bottom: 15px;
					border-bottom: 1px solid #d6d6d6;
					display: flex;
					align-items: center;
					font-size: 14px;
					color: #747474;
	
					.time01{
						margin-left: auto;
						display: flex;
						align-items: center;
						img{
							width: 30px;
							margin-left: 20px;
						}
					}
				}
				.list02{
					margin-top: 23px;
					height: 35px;
					text-overflow: ellipsis;
					white-space: nowrap;
					overflow: hidden;
					font-size: 16px;
					color: #000;
				}
				.list03{
					line-height: 22px;
					min-height:66px;
					max-height: 66px;
					font-size: 14px;
					color: #747474;
					-webkit-transition: all .5s;
					display: -webkit-box;
					-webkit-line-clamp: 3;
					overflow: hidden;
					text-overflow: ellipsis;
					-webkit-box-orient: vertical;
				}
				.list03:hover{
					color: #00b0f0;
				}
				.list02:hover{
					color: #00b0f0;
				}
				.list01{
					width:100%;
					height: 220px;
					border-radius: 5px;
					background: #f5f5f5;
					img{
						width: 100%;
						height: 100%;
						border-radius: 5px;
						transition: all 1s;
					}
					img:hover{
						transform: scale(1.1);
					}
				}
			}
			.lists:nth-child(2){
				margin-left: auto;
			}
		}
	
	}
	.wrapper{
		width: 1200px;
		margin: 0 auto;
		.wrappers{
			display: flex;
			// height: 800px;
			// margin-top:30px;
			.wrappers01{
				width: 816px;
				height: 100%;
				.flexgb{
					width: 100%;
					height: 57px;
					border-bottom: 1px solid #bbcae6;
					display: flex;
					.flexAc{
						color: #00b0f0;
						font-size: 14px;
						margin-left: auto;
						height:100%;
						display: flex;
						align-items: center;
						justify-content: center;
						cursor: pointer;
					}
				}
			}
			.wrappers02{
				width: 345px;
				height: 100%;
				margin-left: auto;
			}
		}
	}
	.swiper{
		width: 80%;
		margin: 0 auto;
		.el-carousel-item{
			width: 100%;
			height: 100%;
			img{
				width: 100%;
				height: 100%;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/huanjing/list.vue